import { useEffect } from 'react';
export const usePageScrollLock = () => {
  useEffect(() => {
    const {
      body
    } = document;
    const {
      scrollY
    } = window;
    const {
      position,
      top,
      width,
      overflowY
    } = body.style;
    Object.assign(body.style, {
      position: 'fixed',
      top: `-${scrollY}px`,
      width: '100%',
      overflowY: 'scroll'
    });
    return () => {
      Object.assign(body.style, {
        position,
        top,
        width,
        overflowY
      });
      window.scrollTo(0, scrollY);
    };
  }, []);
};
//# sourceMappingURL=usePageScrollLock.js.map